import axios from 'axios';
import store from '../vuex/store';

let authRedirecting = false;

function clearSessionAndGoLogin() {
    if (authRedirecting) {
        return;
    }
    authRedirecting = true;
    localStorage.removeItem('logintoken');
    localStorage.removeItem('userData');
    localStorage.removeItem('userdata');
    store.commit('logout', 'false');
    // Avoid importing router here (circular: router → login → userMG → axiosFun).
    window.location.hash = '#/login';
}

axios.interceptors.response.use(
    function (res) {
        return res;
    },
    function (err) {
        var status = err.response && err.response.status;
        var url = (err.config && err.config.url) || '';
        if (status === 401 && url.indexOf('/pc/apps/login') === -1) {
            clearSessionAndGoLogin();
        }
        return Promise.reject(err);
    }
);

// 登录请求方法
const loginreq = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
        const body = res.data;
        if (body && typeof body === 'object' && body.data !== undefined && body.result === undefined) {
            return Object.assign({}, body, { result: body.data });
        }
        return body;
    });
};
// 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            Authorization: localStorage.getItem('logintoken'),
        },
        data: params,
        traditional: true,
        transformRequest: [
            function (data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => {
        const body = res.data;
        if (body && typeof body === 'object' && body.data !== undefined && body.result === undefined) {
            return Object.assign({}, body, { result: body.data });
        }
        return body;
    });
};

export {
    loginreq,
    req
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js